// LIST
export const FETCH_TEAMS = "app/TEAM/FETCH_TEAMS";
export const FETCH_TEAMS_SUCCESS = "app/TEAM/FETCH_TEAMS_SUCCESS";
export const FETCH_TEAMS_FAILURE = "app/TEAM/FETCH_TEAMS_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/TEAM/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/TEAM/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/TEAM/GET_VIEW_DATA_FAILURE";

// ADD
export const ADD_TEAM = "app/TEAM/ADD_TEAM";
export const ADD_TEAM_SUCCESS = "app/TEAM/ADD_TEAM_SUCCESS";
export const ADD_TEAM_FAILURE = "app/TEAM/ADD_TEAM_FAILURE";

// EDIT
export const EDIT_TEAM = "app/TEAM/EDIT_TEAM";
export const EDIT_TEAM_SUCCESS = "app/TEAM/EDIT_TEAM_SUCCESS";
export const EDIT_TEAM_FAILURE = "app/TEAM/EDIT_TEAM_FAILURE";

// DELETE
export const DELETE_TEAM = "app/TEAM/DELETE_TEAM";
export const DELETE_TEAM_SUCCESS = "app/TEAM/DELETE_TEAM_SUCCESS";
export const DELETE_TEAM_FAILURE = "app/TEAM/DELETE_TEAM_FAILURE";

export const TOGGLE_TEAM_ADD_MODAL = "app/TEAM/TOGGLE_TEAM_ADD_MODAL";

export const SEARCH_TEAMS = "app/TEAM/SEARCH_TEAMS";
export const SEARCH_TEAMS_SUCCESS = "app/TEAM/SEARCH_TEAMS_SUCCESS";
export const SEARCH_TEAMS_FAILURE = "app/TEAM/SEARCH_TEAMS_FAILURE";
